import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { isObject, has } from 'lodash';

import { Field } from 'redux-form';

import FormField, { renderLabel, renderDescription, renderSubtext } from './form-field';
import { renderGenericField } from './render-consumer-field';
import textFromAddress from '../lib/consumer-fields/text-from-address'

import { formatMessage } from '../lib/intl';

import '../css/render-special-consumer-field.css';

const i18n = defineMessages({
  addNewPhone: {
    id: "renderSpecialConsumerFields.addNewPhone",
    defaultMessage: "New phone",
  },
  addNewAddress: {
    id: "renderSpecialConsumerFields.addNewAddress",
    defaultMessage: "New address",
  },
});



const makeEvent = value => ({
  stopPropagation() { },
  preventDefault() { },
  target: { value },
});

class RenderSpecialConsumerField extends React.Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);

    this.state = {
      options: [...props.options],
      showNewField: false,
      value: props.input.value,
    }
  }

  onBlur = (ev) => {
    has(this.props, 'onBlur') && this.props.onBlur(ev);
    has(this.props, 'input.onBlur') && this.props.input.onBlur(ev);
  }

  onChange = (ev) => {
    has(this.props, 'onChange') && this.props.onChange(ev);
    has(this.props, 'input.onChange') && this.props.input.onChange(ev);
  }

  onOptionChange = (e) => {
    const { value } = e.target;

    if (value === ' ') {
      this.setState({
        showNewField: true,
      });
    } else {
      this.setState({
        showNewField: false,
      });
    }

    this.setState({
      value,
    });

    this.onBlur(makeEvent(value));
    this.onChange(makeEvent(value));
  }

  renderNew(field) {
    const { showNewField } = this.state;

    if (!showNewField) return null;

    return (
      <div className="consumer-field mt-2">
        <Field
          type={field.subType}
          name={`temp_${field.name}`}
          component={FormField}
          onChange={(e) => {
            const value = e.target.value;
            this.onBlur(makeEvent(value));
            this.onChange(makeEvent(value));
          }}
        />
      </div>
    )
  }

  renderSelect = () => {
    const {
      subtext, meta: { touched, error },
      subType,
      input,
    } = this.props;
    const cssClass = touched && error ? 'has-danger' : '';

    return (
      <div className={cssClass}>
        <select
          className="custom-select"
          onChange={(e) => {
            this.onOptionChange(e);
            input.onChange(e);
          }}
          value={this.state.value}
        >
          {this.renderOptions()}
          <option value=' ' key="opt-new">
            {this.formatMessage(subType === "address" ? i18n.addNewAddress : i18n.addNewPhone)}
          </option>
        </select>
        <br />
        {renderSubtext(subtext, touched && error)}
      </div>
    );
  };

  renderOptions() {
    return this.state.options.map((opt, i) => {
      let value;
      if (isObject(opt.value)) {
        value = JSON.stringify(opt.value);
        opt.text = textFromAddress(opt.value);
      } else {
        value = opt.value
        opt.text = value;
      }

      return (
        <option value={value || 'null'} key={`opt-${i}`}>{opt.text}</option>
      );
    });
  }

  renderDropDown() {
    const {
      label,
      required,
      id,
      description,
    } = this.props;

    return (
      <div className="consumer-field single-select-field">
        <div className="form-group">
          {renderLabel(label, required, id)}
          {renderDescription(description)}
          {this.renderSelect()}
        </div>
      </div>
    );
  }

  render() {

    return (
      <div>
        {this.state.options.length ? this.renderDropDown()
          : renderGenericField({ ...this.props, type: this.props.subType, name: this.props.input.name })}
        {this.renderNew(this.props)}
      </div>
    );
  }
}

RenderSpecialConsumerField.defaultProps = {
  onBlur: () => { },
  onChange: () => { },
}

export default injectIntl(RenderSpecialConsumerField);



// WEBPACK FOOTER //
// ./src/desktop/components/render-special-consumer-field.js